import React from 'react'
import AppContext from 'AppContext'
import KeySearch from './scenes/List/components/KeySearch'
import { env, adminEmail } from 'components/Helpers'

const MembershipsV2 = (props) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index members' />
    )
  }

  const currentUser = adminEmail(JSON.parse(window.localStorage.getItem('currentAdmin')))

  // Must leave empty h1 there for element below not to be cropped...
  //
  // currentuser required for feature flag only
  return (
    <div className='index members'>
      {/* eslint-disable-next-line */}
      <h1 />
      <cl-membership-list
        mountpath={`/operators/${id}/memberships`}
        currentuser={currentUser}
        apihost={`https://memberships.${env()}.credlock.net`}
        operatorid={id}
        token={token}
      />
      <KeySearch
        operatatorid={id}
      />
    </div>
  )
}

export default MembershipsV2
